import { createSlice } from '@reduxjs/toolkit'

const autoShareDiscoveryModalSlice = createSlice({
  name: 'autoShareDiscoveryModal',
  initialState: {
    showModal: false,
    showSpotlight: false,
    spotlightType: null, // 'enabled' or 'deferred'
  },
  reducers: {
    closeAutoShareDiscoveryModal: (state) => {
      state.showModal = false
    },
    showAutoShareDiscoveryModal: (state) => {
      state.showModal = true
    },
    showAutoShareSpotlight: (state, { payload }) => {
      if (payload !== 'enabled' && payload !== 'deferred') return
      state.showSpotlight = true
      state.spotlightType = payload
    },
    clearAutoShareSpotlight: (state) => {
      state.showSpotlight = false
      state.spotlightType = null
    },
  },
})

export const {
  reducer,
  actions: {
    closeAutoShareDiscoveryModal,
    showAutoShareDiscoveryModal,
    showAutoShareSpotlight,
    clearAutoShareSpotlight,
  },
} = autoShareDiscoveryModalSlice
